import React from "react";
import { useHistory } from "react-router-dom";
import { Navbar, Nav, NavDropdown, Form, FormControl, Button } from "react-bootstrap";
import Logo from '../../assets/images/logo-dark.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function Footer() {


    const history = useHistory();
    const pathname = history.location.pathname;


    return (
        <footer>
            <div className="top-footer main-padding">
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="site-info">
                                <div className="logo">
                                    <img src={Logo} alt="" className="img-fluid" />
                                </div>
                                <h5>The world’s first and largest digital marketplace for crypto collectibles and non-fungible tokens (NFTs). Buy, sell, and discover exclusive digital assets.</h5>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="row">
                                <div className="col-md-4">
                                    <h3>NAVIGATION</h3>
                                    <ul className="footer-links">
                                        <li>
                                            <a href="#">Home </a>
                                        </li>
                                        <li>
                                            <a href="#">Explore </a>
                                        </li>
                                        <li>
                                            <a href="#">Activity </a>
                                        </li>
                                        <li>
                                            <a href="#">Pages </a>
                                        </li>
                                        <li>
                                            <a href="#">Community</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-4">
                                    <h3>EXPLORE</h3>
                                    <ul className="footer-links">
                                        <li>
                                            <a href="#">Explore Artworks </a>
                                        </li>
                                        <li>
                                            <a href="#">Single Artwork </a>
                                        </li>
                                        <li>
                                            <a href="#">Explore Creators</a>
                                        </li>
                                        <li>
                                            <a href="#"> Single Creator</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-4">
                                    <h3>COMMUNITY</h3>
                                    <ul className="footer-links">
                                        <li>
                                            <a href="#">Blog </a>
                                        </li>
                                        <li>
                                            <a href="#">Help Center</a>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="footer-botton main-padding">
                <div className="container-fluid p-0">
                    <div className="copyrights">
                        <p>Copyright © 2021 by toppy. All rights reserved.</p>
                        <ul className="bottom-links">
                            <li>
                                <a href="#">Terms & Conditions</a>
                            </li>
                            <li>
                                <a href="#">Privacy Policy</a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </footer>

    )
}
export default Footer;